import Instance from '../../../utils/Axios';

const RecursosDefinidos = (id) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .get(`/obras/associarobras/${id}/recursos`)
      .then(({ data }) => {
        if (stateToken) {
          dispatch({ type: 'GET_RECURSOS_DEFINIDOS', payload: data.yData });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default RecursosDefinidos;
